import { JSX } from 'react';
import { TextField } from '@mui/material';

interface Props {
  value: string;
  onChange: (v: string) => void;
}

export default function ZipCodeInput({ value, onChange }: Props): JSX.Element {
  return (
    <TextField
      fullWidth
      value={value}
      onChange={(e) => onChange(e.target.value)}
      inputProps={{
        inputMode: 'numeric',
        maxLength: 10,
        'data-testid': 'zip-input',
      }}
      placeholder="12345 or 12345-6789"
      sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
    />
  );
}
